/* Waiting, drawn in the same ink as everything else.
 *
 * No spinning gradient ring: a ring is a different design language wearing our
 * colours, and it implies a smoothness this system does not have anywhere else.
 * Five hard squares snapping on and off on a steps(1) cycle is the same idea in
 * this vocabulary — it is a level meter with nothing coming in.
 *
 * It always carries a word. "Something is happening" is what a spinner says;
 * "Loading the schedule" is what a person needs, and it is the half a screen
 * reader can actually use.
 */

import { usePrefersReducedMotion } from './shared';

const BARS = [0, 1, 2, 3, 4];

export interface SpinnerProps {
  /** What is being waited for. Written as a sentence, not a gerund fragment. */
  label?: string;
  /** Hide the word visually and leave it for screen readers only. */
  quiet?: boolean;
  className?: string;
}

export function Spinner({ label = 'Loading', quiet = false, className }: SpinnerProps) {
  const reduced = usePrefersReducedMotion();

  return (
    <div className={className ? `spin ${className}` : 'spin'} role="status">
      <span className="spin__bars" data-still={reduced ? 'true' : undefined} aria-hidden="true">
        {BARS.map((i) => (
          <i key={i} style={{ animationDelay: `${i * 120}ms` }} />
        ))}
      </span>
      <span className={quiet ? 'vh' : 'mono spin__label'}>{label}</span>
    </div>
  );
}
